import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { BARACK_NAMES, Constants } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { UserDataService } from "app/helpers/user-data.service";
import { environment } from "environments/environment";

@Component({
  selector: "event-finance-card",
  templateUrl: "./event-finance-card.component.html",
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class EventFinanceCardComponent implements OnInit, AfterViewInit {
  parameters: any = {};
  rights: any = [];
  @Input() event: any = {};

  MAADHANTHIRA_SANDHA = Constants.MAADHANTHIRA_SANDHA;
  POTHU_VARAVU_SELAVU = Constants.POTHU_VARAVU_SELAVU;
  PORUPALAR_NIYAMANA_THEERMANAM = Constants.PORUPALAR_NIYAMANA_THEERMANAM;
  THOGUTHI_KALANTHAIVU = Constants.THOGUTHI_KALANTHAIVU;
  barracks = BARACK_NAMES;
  API_FILES = environment.API_FILES;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,

    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
    });

    this.rights = this.userDataService.userData.rights[
      this.parameters.party_post_id
    ];
  }

  ngAfterViewInit(): void { }

  isImage(file: string) {
    var isValidFileExtension = [".jpg", ".jpeg", ".gif", ".bmp", ".png"];
    var status = false;
    isValidFileExtension.forEach((val) => {
      if (file.toLowerCase().endsWith(val)) {
        status = true;
      }
    });

    return status;
  }
}
